import { ApiResponse } from "types/api";

import { Manifest, ManifestPartial, ManifestRaw } from "./types";

export function transformManifestRequestBody(
  body: ManifestPartial
): Partial<ManifestRaw> {
  return {
    ...body.attributes,
    provider_id: body.provider_id,
    targets: body.targets,
  };
}

export function transformManifestResponse(
  response: ApiResponse<ManifestRaw>
): ApiResponse<Manifest> {
  const {
    id,
    application_configuration_id,
    provider_id,
    created_date,
    is_deleted,
    modified_by,
    modified_date,
    targets,
    ...attributes
  } = response.results;
  return {
    ...response,
    results: {
      id,
      application_configuration_id,
      provider_id,
      attributes,
      created_date,
      is_deleted,
      modified_by,
      modified_date,
      targets,
    },
  };
}
